<template>
  <v-card class="card-flex">
      <v-img :src="getPictureUrl(education.image)" :height="200" :max-height="200" aspect-ratio="900/400"/>
      <h3 class="headline mb-0 tutor">{{ education.name }}</h3>
      <v-card-title class="card-title">
        <div class="w100">
          <div class="subheader w100 pb-2">
            <span class="grey--text">{{ education.tutor }}</span>
            <span class="grey--text">{{ getDate(education.created_at) }}</span>
          </div>
          <div>{{ getShortDescription() }}</div>
        </div>
      </v-card-title>
      <v-flex>
        <v-card-actions class="actions">
          <v-btn @click="showEducation" color="primary">
            {{ 'app.select' | trans }}
          </v-btn>
        </v-card-actions>
      </v-flex>
  </v-card>
</template>

<script>

export default {
  props: {
    education: Object,
    isGranted: Boolean,
  },
  methods: {
    getDate(dateTime) {
      return moment(dateTime).format('DD.MM.Y');
    },
    showEducation() {
      window.location.href = `/education/${this.education.id}`;
    },
    getPictureUrl(url) {
      return `/photos/education/${url}`;
    },
    getShortDescription() {
      if (this.education.short_description.length <= 420) {
        return this.education.short_description;
      }

      return `${this.education.short_description.slice(0, 416)}...`;
    },
  },
};
</script>

<style scoped>
.tutor {
  padding-left: 16px;
  padding-right: 16px;
}

.actions {
  display: flex;
  justify-content: center;
}

.card-flex {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.card-flex > div {
  flex: 0 1 auto;
}

.card-title {
  flex: 1 1 auto !important;
  align-items: start;
}

.subheader {
  display: flex;
  justify-content: space-between;
}

.w100 {
  width: 100%;
}
</style>
